export default __webpack_public_path__ + "static/media/254.f640be83.png";